

// UI-Sounds komplett deaktiviert (2026-07-11): statt use-sound/Howler gibt
// der Hook stumme No-op-Funktionen zurück — dadurch werden die 8 MP3s
// (clickAudio_, mouseIn/Out, timeslider, Door_open, Abdeckung_open, fly,
// CheckInArea) gar nicht mehr geladen. Die 15 aufrufenden Komponenten
// bleiben unverändert und rufen ins Leere.
// Zum Reaktivieren: git-History dieser Datei — die alte Version lud alle
// Sounds via useSound('../Sounds/…', { volume: … }).

const noop = () => {};

const Sound = () => {
  return {
    playClickSound: noop,
    playMouseIn: noop,
    playMouseOut: noop,
    playTimelslider: noop,
    playDoorOpen: noop,
    playAbdeckungOpen: noop,
    playFly: noop,
    playCheckArea: noop,
  };
};

export default Sound;
